import React from 'react';

import { HeaderWrapper, ButtonWrapper, LabelWrapper } from './styles';

import CloseButton from '@mui/icons-material/Close';

import { requestClose } from '../../../../../environment_modules/xcore/external-store'; //'../../external-store';

const Header = (props) => {
  const { title } = props;
  const headerLabel = title;

  return (
    <HeaderWrapper>
      <ButtonWrapper onClick={() => requestClose()} isHidden={false} >
        <CloseButton style={{ color: '#202020' }} />
      </ButtonWrapper>
      <LabelWrapper>
        {headerLabel}
      </LabelWrapper>
      <></>
    </HeaderWrapper>
  );
};

export default React.memo(Header);
